import React from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { Collapse } from "@mui/material";
import BaseSwitch from "@reusables/BaseSwitch";
import { useTranslation } from "react-i18next";
import { DefaultsFormTyping } from "../types";

export default function ReservationsSetting() {
    const { t } = useTranslation("", { keyPrefix: "settings.general.defaults.settings.reservations" });

    const { control } = useFormContext<DefaultsFormTyping>();

    const isReservationsEnabled = useWatch({ control, name: "enable_reservations" });

    return (
        <div className={"bg-[#F9F9F9] border-1 border-solid border-[#D9D6DA] rounded-md"}>
            <div className={"flex flex-row items-center justify-between p-3 gap-4"}>
                <div className="flex flex-col gap-2">
                    <div className="text-accent">
                        {t("label")}
                    </div>
                    <div className="text-sm text-gray-500">
                        {t("description")}
                    </div>
                </div>
                <div>
                    <Controller
                        name="enable_reservations"
                        control={control}
                        render={({ field }) => (
                            <BaseSwitch
                                checked={field.value}
                                onChange={(_, checked) => field.onChange(checked)}
                            />
                        )}
                    />
                </div>
            </div>

            {/* Per-location reservations only refine reservations, so the option is revealed only when they are enabled */}
            <Collapse in={isReservationsEnabled}>
                <div className={"flex flex-row items-center justify-between p-3 pl-6 gap-4 border-0 border-t border-solid border-[#D9D6DA]"}>
                    <div className="flex flex-col gap-2">
                        <div className="text-accent">
                            {t("perLocation.label")}
                        </div>
                        <div className="text-sm text-gray-500">
                            {t("perLocation.description")}
                        </div>
                    </div>
                    <div>
                        <Controller
                            name="enable_location_reservations"
                            control={control}
                            render={({ field }) => (
                                <BaseSwitch
                                    checked={field.value}
                                    onChange={(_, checked) => field.onChange(checked)}
                                />
                            )}
                        />
                    </div>
                </div>
            </Collapse>
        </div>
    );
}
